import { Container, Box, Heading, Text } from '@chakra-ui/react';

export default function BoxHeading({
  title,
  text,
  color,
  maxW,
}: {
  title: string;
  text?: string;
  color?: string;
  maxW?: string;
}) {
  return (
    <Container>
      <Box bgColor="white" p={{ base: '1.5rem 1.5rem 2.5rem', lg: '3.5rem 0 ' }} textAlign="center">
        <Box maxW={maxW} mx="auto">
          <Heading
            as="h2"
            color={color}
            fontSize={{ base: '1.75rem', lg: '2rem' }}
            lineHeight={{ base: '2rem', lg: '2.25rem' }}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
            sx={{
              a: {
                textDecoration: 'underline',
              },
            }}
          />
          {text && (
            <Text
              mt={{ base: '4', lg: '6' }}
              dangerouslySetInnerHTML={{
                __html: text,
              }}
              sx={{
                a: {
                  textDecoration: 'underline',
                },
              }}
            />
          )}
        </Box>
      </Box>
    </Container>
  );
}
